export const ExperimentsConsts = {
  EditorOOIFormPage: 'specs.bookings.EditorOOIFormPage',
  FormEditorKBContent: 'specs.bookings.FormEditorKBContent',
  MultiLocationUoU: 'specs.bookings.MultiLocationUoU',
  FormAddH1HeaderForA11y: 'specs.bookings.FormAddH1HeaderForA11y',
  AddonsUOU: 'specs.bookings.AddonsUOU',
};
